import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  ButtonIcon,
  Input,
  Text,
} from '@cubeyou-team/hx-react-components';
import { useSelector } from 'react-redux';
import { DATA_SOURCE_IDS } from '@discover-frontend/constants';

import { QueryBuilderConstants } from 'src/modules/query-builder/constants';
import {
  StyledAtLeastNumber,
  StyledQueryActionsHeader,
} from './StyledQueryActions';
import { QueryOperator } from '..';
import { findGroupLevel, isEmpty } from '../../../../utils/misc';

const QueryActions = ({
  group,
  index,
  parentGroupId,
  canDelete,
  showOperator,
  onChangeGroupOperatorRequest,
  onDeleteGroupRequest,
  onChangeGroupAtLeastNumberRequest,
  onHighlightGroup,
}) => {
  const dataSource = useSelector(state => state.queryBuilder.dataSource);
  const selectedTarget = useSelector(
    state => state.queryBuilder.target_selected
  );
  const query = useSelector(
    state => state.queryBuilder.targets[selectedTarget]
  );

  if (!query) return <div />;

  const { operator, at_least } = group;
  const level = findGroupLevel(query.target_query, group.id, 0);
  const operatorLevel = level >= 0 ? level : 0;
  const availableAtLeastNumber =
    !isEmpty(at_least) &&
    Number(at_least) > 0 &&
    Number(at_least) <= group.arguments_list.length;

  const availableOperators = useMemo(() => {
    const isEnabled = dataSource === DATA_SOURCE_IDS.TWITTER;

    return [
      {
        id: 'OR',
        label: 'OR (Any)',
        enabled: true,
      },
      {
        id: 'AND',
        label: 'AND (All)',
        enabled: true,
      },
      {
        id: 'NOT (AND)',
        label: 'NOT AND (Exclude)',
        enabled: true,
      },
      {
        id: 'AT_LEAST',
        label: 'AT LEAST',
        enabled: isEnabled,
      },
    ].filter(operator => operator.enabled);
  }, [dataSource]);

  return (
    <StyledQueryActionsHeader>
      <Row halign="between">
        <Col span="auto">
          {showOperator && (
            <Row valign="middle">
              <Col span="auto">
                <QueryOperator
                  level={operatorLevel}
                  operator={operator}
                  onOperatorChange={operator => {
                    onChangeGroupOperatorRequest(group.id, operator);
                  }}
                  onHighlightOperator={onHighlightGroup}
                  availableOperators={availableOperators}
                />
              </Col>
              {operator === 'AT_LEAST' && (
                <>
                  <Col span="auto">
                    <StyledAtLeastNumber
                      colors={
                        QueryBuilderConstants.groupOperatorColors[
                          operatorLevel % 7
                        ]
                      }
                      error={!availableAtLeastNumber}
                    >
                      <Input
                        type="text"
                        name={`at-least-number-${group.id}`}
                        size="thin"
                        value={at_least}
                        onChange={e => {
                          e.persist();

                          onChangeGroupAtLeastNumberRequest(
                            group.id,
                            e.target.value
                          );
                        }}
                        autoFocus
                        style={{ width: '100%' }}
                        error={!availableAtLeastNumber}
                      />
                    </StyledAtLeastNumber>
                  </Col>
                  <Col span="auto">
                    <Text size="small">Of these Attributes</Text>
                  </Col>
                </>
              )}
            </Row>
          )}
        </Col>
        {canDelete && (
          <Col span="auto">
            <ButtonIcon
              icon="delete"
              size="small"
              type="button"
              variant="dark_lighter"
              onClick={() => {
                onDeleteGroupRequest(parentGroupId, index);
              }}
            />
          </Col>
        )}
      </Row>
    </StyledQueryActionsHeader>
  );
};

QueryActions.propTypes = {
  group: PropTypes.object,
  canDelete: PropTypes.bool,
  showOperator: PropTypes.bool,
  onChangeGroupOperatorRequest: PropTypes.func,
  onAddEntityRequest: PropTypes.func,
  onAddGroupRequest: PropTypes.func,
  onDeleteGroupRequest: PropTypes.func,
};

QueryActions.defaultProps = {
  canDelete: true,
  showOperator: true,
  group: {},
};

export default QueryActions;
